import axios from 'axios';
import { SettingsSchema } from '../types';

const ABSOLUTE_ASSET_URL_RE = /^(?:[a-z]+:)?\/\//i;

function getAppHostname(): string {
  return window.location.hostname;
}

function getAssetsBasePath(app?: string): string {
  const hostname = app || getAppHostname();
  return `/assets/${hostname}`;
}

export async function getSettings(app?: string): Promise<SettingsSchema> {
  const basePath = getAssetsBasePath(app);
  const response = await axios.get<SettingsSchema>(`${basePath}/settings.json`);
  return response.data;
}

export async function getStaticContent(file: string, app?: string): Promise<string> {
  const basePath = getAssetsBasePath(app);
  const response = await axios.get<string>(`${basePath}/content/${file}`);
  return response.data;
}

export function getAssetUrl(path: string, app?: string): string {
  const basePath = getAssetsBasePath(app);
  return `${basePath}/${path}`;
}

export function resolveAssetUrl(path: string, app?: string): string {
  if (!path) {
    return path;
  }

  if (
    ABSOLUTE_ASSET_URL_RE.test(path) ||
    path.startsWith('/') ||
    path.startsWith('data:')
  ) {
    return path;
  }

  return getAssetUrl(path, app);
}

export function loadClientStylesheet(app?: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const basePath = getAssetsBasePath(app);
    const existing = document.getElementById('client-stylesheet');

    if (existing) {
      existing.remove();
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${basePath}/style.css`;
    link.id = 'client-stylesheet';
    link.onload = () => resolve();
    link.onerror = () => {
      console.warn(`Could not load client stylesheet for ${app || getAppHostname()}`);
      resolve(); // resolve anyway so the app still renders
    };
    document.head.appendChild(link);
  });
}

export { getAppHostname, getAssetsBasePath };
